// Claims list page (AllClaims.vue): what it opens on, the month and status controls in the table header and the
// facility cards. Same file in the five maintained frontends.
import moment from "moment";

// Claims are treated a month at a time. Facility users still see the current month, so a claim they just
// submitted is on the page.
const defaultMonth = (user) => {
  const isFacility = user.type === "provider" || user.type === "provider_employee";
  return (isFacility ? moment() : moment().subtract(1, "month")).format("YYYY-MM");
};

// The month a date range is exactly, else "" (custom dates or all dates).
const monthOfRange = (from, to) => {
  if (!from || !to) return "";
  const start = moment(from, "YYYY-MM-DD");
  return start.date() === 1 && start.clone().endOf("month").format("YYYY-MM-DD") === to ? start.format("YYYY-MM") : "";
};

export default {
  data() {
    return {
      month: "",
      // the filters the facility cards use; replaced when filters are applied, not on every keystroke
      summaryParams: null,
    };
  },
  computed: {
    isAgencyStaff() {
      const user = JSON.parse(localStorage.getItem("user")) || {};
      return user.type === "shis" || user.type === "employee";
    },
    periodLabel() {
      return this.from || this.to ? `Data from ${this.from || "the start"} to ${this.to || "today"}` : "All dates";
    },
    claimStatusOptions() {
      const user = JSON.parse(localStorage.getItem("user")) || {};
      const options = [
        { value: "", label: "All statuses" },
        { value: "pending", label: "Pending" },
        { value: "vetted", label: "Vetted" },
        { value: "verified", label: "Verified" },
        { value: "forwarded", label: "Forwarded to ES" },
        { value: "approved", label: "Approved" },
        { value: "sent_back", label: "Sent back to facility" },
        { value: "suspended", label: "Suspended" },
        { value: "rejected", label: "Rejected" },
      ];
      if (user.type === "provider" || user.type === "provider_employee") options.splice(1, 0, { value: "draft", label: "Draft" });
      return options;
    },
  },
  created() {
    // Runs before the page's own created(), which loads the claims.
    const user = JSON.parse(localStorage.getItem("user")) || {};
    const query = this.$route.query;
    const title = (user.job_title || "").trim().toLowerCase();

    if (query.status !== undefined) this.claim_status = query.status === "all" ? "" : query.status;
    else if (title === "claims vetter") this.claim_status = "pending";
    else if (title === "claims verifier") this.claim_status = "vetted";

    this.month = query.period === "all" ? "" : /^\d{4}-\d{2}$/.test(query.month || "") ? query.month : defaultMonth(user);
    this.setPeriodFromMonth();
    this.refreshFacilitySummary();
  },
  methods: {
    setPeriodFromMonth() {
      const month = this.month ? moment(this.month, "YYYY-MM") : null;
      this.from = month ? month.clone().startOf("month").format("YYYY-MM-DD") : "";
      this.to = month ? month.clone().endOf("month").format("YYYY-MM-DD") : "";
    },
    onMonthChange() {
      this.setPeriodFromMonth();
      this.applyFilters();
    },
    applyFilters() {
      this.month = monthOfRange(this.from, this.to);
      this.getClaims(1);
      this.refreshFacilitySummary();
    },
    refreshFacilitySummary() {
      this.summaryParams = {
        from: this.from || undefined,
        to: this.to || undefined,
        sector: this.sector || undefined,
        phc_type: this.phc_type || undefined,
        phc_general: this.phc_general || undefined,
      };
    },
    selectFacility(facility) {
      this.provider_id = facility ? { id: facility.provider_id, agency_name: facility.agency_name } : "";
      this.getClaims(1);
    },
    selectStatus(status) {
      this.claim_status = status;
      this.getClaims(1);
    },
  },
};
